import { StatementCollectionModel, StatementModel } from "@bToC/Services/GerrieApiModels";
import { GetStatementsApiParameter } from "@bToC/Services/StatementService";
import { StatementDataState } from "@bToC/Store/Data/Statements/StatementState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { Draft } from "immer";

const initialStatementDataState: StatementDataState = {
    isLoading: {},
    idByStatmentNumber: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {

    "Data/Statement/BeginLoadStatementData": (
        draft: Draft<StatementDataState>,
        action: { parameter: GetStatementsApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/Statement/CompleteLoadStatementData": (
        draft: Draft<StatementDataState>,
        action: { parameter: GetStatementsApiParameter; collection: StatementCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.statements!,
            statement => storeIdByStatementNumber(draft, statement),
        );

        if (draft.failedToLoadStatements) {
            draft.failedToLoadStatements = false;
        }
    },

    "Data/Statement/FailedToLoadStatements": (draft: Draft<StatementDataState>) => {
        draft.failedToLoadStatements = true;
    },

    "Data/Statement/BeginLoadStatementByStatementNumber": (
        draft: Draft<StatementDataState>,
        action: { statementNumber: string },
    ) => {
        draft.isLoading[action.statementNumber] = true;
    },

    "Data/Statement/CompleteLoadStatementByStatementNumber": (
        draft: Draft<StatementDataState>,
        action: { model: StatementModel },
    ) => {
        delete draft.isLoading[action.model.statementNumber];
        draft.byId[action.model.id] = action.model;
        storeIdByStatementNumber(draft, action.model);
        if (draft.errorStatusCodeById) {
            delete draft.errorStatusCodeById[action.model.statementNumber];
        }
    },

    "Data/Statement/FailedToLoadStatementByStatementNumber": (
        draft: Draft<StatementDataState>,
        action: { statementNumber: string; status: number },
    ) => {
        delete draft.isLoading[action.statementNumber];
        if (draft.errorStatusCodeById) {
            draft.errorStatusCodeById[action.statementNumber] = action.status;
        }
    },

    "Data/Statement/Reset": () => {
        return initialStatementDataState;
    },
};

function storeIdByStatementNumber(draft: Draft<StatementDataState>, statement: StatementModel) {
    draft.idByStatmentNumber[statement.statementNumber] = statement.id;
}

export default createTypedReducerWithImmer(initialStatementDataState, reducer);
